import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { SiaSelectBoxComponent, SiaTextBoxComponent } from '@sia/inputs';
import { notify } from '@sia/shared';

@Component({
  selector: 'dialog-overview-example-dialog',
  template: ` <span class="sia-heading" mat-dialog-title
      >Nuova prospettiva</span
    >
    <div mat-dialog-content style="font-size: 14px; padding:  8px">
      <sia-text-box
        [(value)]="data.name"
        label="Nome della prospettiva*"
        style="font-size: 18px"
      ></sia-text-box>
      <sia-select-box
        [selectBoxOptions]="{
          fixedDataSource: defaultModes,
          value: 'A',
        }"
        [(value)]="data.defaultMode"
        style="font-size: 18px; padding-top: 8px;"
        label="Default"
      ></sia-select-box>
    </div>

    <div
      mat-dialog-actions
      style="display: flex; justify-content: center; gap: 8px; width : 100%"
    >
      <button mat-raised-button (click)="onNoClick()" color="warn">
        CHIUDI
      </button>
      <button
        mat-raised-button
        (click)="onYesClick()"
        cdkFocusInitial
        color="primary"
      >
        SALVA
      </button>
    </div>`,
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    SiaTextBoxComponent,
    MatDialogActions,
    MatButton,
    SiaSelectBoxComponent,
  ],
})
export class NewPerspectiveDialogComponent {
  dialogRef = inject<MatDialogRef<NewPerspectiveDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  /** Inserted by Angular inject() migration for backwards compatibility */
  defaultModes: { id: string | null; description: string }[] = [
    { id: 'O', description: 'Altro' },
    { id: 'A', description: 'Tutti' },
    { id: 'M', description: 'Mobile' },
    { id: 'D', description: 'Desktop' },
  ];
  constructor() {}

  onNoClick(): void {
    this.dialogRef.close();
  }
  onYesClick() {
    if (this.data.name) {
      this.data.reference = 'MASTER';
      this.dialogRef.close(this.data);
    } else {
      notify('Selezionare un nome per la prospettiva', 2000, 'error');
    }
  }
}
